module.exports = __webpack_public_path__ + "media/src/images/zu_teaching_uni_page-85f30b54abbcb406bd4752f1c0836136.png";